var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noticeCom"},[(!_vm.isCloseAlert && _vm.operatorNotice.status)?_c('div',[_c('el-alert',{attrs:{"title":"友情提示","type":"info","description":_vm.operatorNotice.notice,"show-icon":"","effect":"dark"},on:{"close":_vm.closeAlert}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }